[
    {
      "display": "true",
      "ui_columnname": "Order Id",
      "db_columnname": "orderId",
      "datatype": "char",
      "mappingkey": "orderId",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Buy sell",
      "db_columnname": "buysell",
      "datatype": "char",
      "mappingkey": "buysell",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "OpenClose",
      "db_columnname": "openClose",
      "datatype": "char",
      "mappingkey": "openClose",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "OsiCode",
      "db_columnname": "osiCode",
      "datatype": "char",
      "mappingkey": "osiCode",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Underlying Symbol",
      "db_columnname": "underlyingSymbol",
      "datatype": "char",
      "mappingkey": "underlyingSymbol",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "CallPut",
      "db_columnname": "callPut",
      "datatype": "char",
      "mappingkey": "callPut",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Expiry Date",
      "db_columnname": "expiryDate",
      "datatype": "char",
      "mappingkey": "expiryDate",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Strike Price",
      "db_columnname": "strikePrice",
      "datatype": "char",
      "mappingkey": "strikePrice",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Quantity",
      "db_columnname": "quantity",
      "datatype": "char",
      "mappingkey": "quantity",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Price",
      "db_columnname": "price",
      "datatype": "char",
      "mappingkey": "price",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Counterparty Code",
      "db_columnname": "counterpartyCode",
      "datatype": "char",
      "mappingkey": "counterpartyCode",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Account Category",
      "db_columnname": "accountCategory",
      "datatype": "char",
      "mappingkey": "accountCategory",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Commission Rate",
      "db_columnname": "commissionRate",
      "datatype": "char",
      "mappingkey": "commissionRate",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Commission Method",
      "db_columnname": "commissionMethod",
      "datatype": "char",
      "mappingkey": "commissionMethod",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Entered Date",
      "db_columnname": "enteredDate",
      "datatype": "char",
      "mappingkey": "enteredDate",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Cmta Broker",
      "db_columnname": "cmtaBroker",
      "datatype": "char",
      "mappingkey": "cmtaBroker",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Cmta Account",
      "db_columnname": "cmtaAccount",
      "datatype": "char",
      "mappingkey": "cmtaAccount",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Giveup Broker",
      "db_columnname": "giveupBroker",
      "datatype": "char",
      "mappingkey": "giveupBroker",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Entered By",
      "db_columnname": "enteredBy",
      "datatype": "char",
      "mappingkey": "enteredBy",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Order Flags",
      "db_columnname": "orderFlags",
      "datatype": "char",
      "mappingkey": "orderFlags",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Version Number",
      "db_columnname": "versionNumber",
      "datatype": "char",
      "mappingkey": "versionNumber",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Order Leg Id",
      "db_columnname": "orderLegId",
      "datatype": "char",
      "mappingkey": "orderLegId",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    }
  ]